<template>
  <section class="mx-4">
    <v-layout row wrap>
      <v-flex xs12 md12 class="my-2">
        <ChangeImage />
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import ChangeImage from "./ChangeImage.vue";

export default {
  components: { ChangeImage }
};
</script>

<style>
</style>